import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import rose_ring from '../../../Assets/images/magnolia-img/landing-page-img/engagment-static-page-img/rose_ring.png'
import white_ring from '../../../Assets/images/magnolia-img/landing-page-img/engagment-static-page-img/white_ring.png'
import platinum_ring from '../../../Assets/images/magnolia-img/landing-page-img/engagment-static-page-img/platinum_ring.png'
import yellow_ring from '../../../Assets/images/magnolia-img/landing-page-img/engagment-static-page-img/yellow_ring.png'
import { useHistory } from 'react-router-dom'

const MetalType = () => {
    const history = useHistory();
    return (
        <>
            <div className='dfl_eng_metal_type_section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={12} lg={12}>
                            <div className="top_heading_metal">
                                <h2>Browse By Metal Type</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className='w-100 m-auto'>
                        <Col xs={6} sm={6} md={6} lg={6} className="metal_content_left">
                            <div className="banner-adv zoom-image" onClick={() => window.location.pathname === "/wedding-anniversary-bands" ? history.push("/jewelry/wedding-rings/material=14K-Rose-Gold") : window.location.pathname === "/jewelry" ? history.push("/jewelry/fine-jewelry/material=14K-Rose-Gold") : history.push("/ringsettings/metals=Rose-Gold")}>
                                <div className="rose_bg adv-thumb-link">
                                    <img src={rose_ring} alt="Rose Ring" className='img-fluid' />
                                    <div className="metal_inner_cotnent_top">
                                        <h2>Rose Gold</h2>
                                        <p className="desktop_view">Shop Rose Gold Gifts</p>
                                        <p className="mobile_view" style={{ display: 'none' }}>Shop Rose Gold</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6} className="metal_content_right">
                            <div className="banner-adv zoom-image" onClick={() => window.location.pathname === "/wedding-anniversary-bands" ? history.push("/jewelry/wedding-rings/material=14K-White-Gold") : window.location.pathname === "/jewelry" ? history.push("/jewelry/fine-jewelry/material=14K-White-Gold") : history.push("/ringsettings/metals=White-Gold")}>
                                <div className="white_bg adv-thumb-link">
                                    <img src={white_ring} alt="Rose Ring" className='img-fluid' />
                                    <div className="metal_inner_cotnent_top1">
                                        <h2>White Gold</h2>
                                        <p className="desktop_view">Shop White Gold Gifts</p>
                                        <p className="mobile_view" style={{ display: 'none' }}>Shop White Gold</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6} className="metal_content_left">
                            <div className="banner-adv zoom-image" onClick={() => window.location.pathname === "/wedding-anniversary-bands" ? history.push("/jewelry/wedding-rings/material=Platinum") : window.location.pathname === "/jewelry" ? history.push("/jewelry/fine-jewelry/material=Platinum") : history.push("/ringsettings/metals=Platinum")}>
                                <div className="platinum_bg  adv-thumb-link">
                                    <img src={platinum_ring} alt="Rose Ring" className='img-fluid' />
                                    <div className="metal_inner_cotnent_bottom">
                                        <h2>Platinum </h2>
                                        <p className="desktop_view">Shop Platinum Gifts</p>
                                        <p className="mobile_view" style={{ display: 'none' }}>Shop Platinum</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={12} md={6} lg={6} className="metal_content_right">
                            <div className="banner-adv zoom-image" onClick={() => window.location.pathname === "/wedding-anniversary-bands" ? history.push("/jewelry/wedding-rings/material=14K-Yellow-Gold") : window.location.pathname === "/jewelry" ? history.push("/jewelry/fine-jewelry/material=14K-Yellow-Gold") : history.push("/ringsettings/metals=Yellow-Gold")}>
                                <div className="yellow_bg   adv-thumb-link">
                                    <img src={yellow_ring} alt="Rose Ring" className='img-fluid' />
                                    <div className="metal_inner_cotnent_bottom1">
                                        <h2>Yellow Gold  </h2>
                                        <p className="desktop_view">Shop Yellow Gold Gifts</p>
                                        <p className="mobile_view" style={{ display: 'none' }}>Shop Yellow Gold</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default MetalType